import { VortexModTester } from "./utils/VortexModTester";
let testerInstance = null;
/**
 * Test if files are supported by the FOMOD installer
 */
export const testSupported = async (files, details, isBasic) => {
    if (!isBasic && details && details.hasXmlConfigXML === false) {
        return {
            supported: false,
            requiredFiles: [],
        };
    }
    if (testerInstance === null) {
        testerInstance = new VortexModTester();
    }
    const result = testerInstance.testSupport(files, isBasic ? ["Basic"] : ["XmlScript"]);
    return Promise.resolve(result);
};
